"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-top: 50px;\n    padding-left: 25px;\n    padding-right: 30px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FooterWrapper = _styledComponents.default.div.withConfig({
  displayName: "FooterMicrocopy__FooterWrapper",
  componentId: "sc-1xy9pp4-0"
})(["position:relative;padding-top:16px;padding-bottom:20px;z-index:1;color:", ";font-size:12px;clear:both;", ""], _colors.SLINKY, _responsiveBreakpoints.default.tablet(_templateObject()));

var FooterMicrocopy = function FooterMicrocopy() {
  var handleClickLink = function handleClickLink() {
    (0, _getUsageTracker.default)().track('externalLinkClick', {
      name: 'product-services-catalog'
    });
  };

  return _react.default.createElement(FooterWrapper, {
    className: "text-center flex-column"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.productServicesCatalogPrompt_jsx",
    options: {
      onClick: handleClickLink
    },
    elements: {
      UILink: _UILink.default
    }
  }));
};

var _default = FooterMicrocopy;
exports.default = _default;
module.exports = exports.default;